import React from 'react';
import {
  Box,
  Container,
  Heading,
  Text,
  VStack,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  useColorModeValue,
  Flex,
  HStack,
  Button,
  Link,
} from '@chakra-ui/react';
import { Header } from '../components/Header';
import { useNavigate } from 'react-router-dom';
import { FcGoogle } from 'react-icons/fc';
import { useAuth } from '../contexts/AuthContext';
import { useToast } from '@chakra-ui/react';


const FAQ = () => {
  const bg = useColorModeValue('gray.50', 'gray.900');
  const { signIn } = useAuth();
  const navigate = useNavigate();
  const toast = useToast();

  const handleSignIn = async () => {
    try {
      await signIn();
      navigate('/dashboard');
    } catch (error) {
      toast({
        title: 'Error signing in',
        description: error.message,
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    }
  };

  const faqs = [
    {
      question: "Will it work with my existing email?",
      answer: "Yes! Our AI companion works with any email provider. Simply forward your emails or CC our AI's address in your conversations. Whether you use Gmail, Outlook, or any other email service, you can start using our service immediately without changing your current email setup."
    },
    {
      question: "How secure is my data?",
      answer: "We take your privacy and security seriously. All emails and data are encrypted end-to-end, and we follow industry-best security practices. Your data is stored in secure, encrypted databases, and you have complete control over your data retention settings. We never share your personal information with third parties, and you can request data deletion at any time."
    },
    {
      question: "What patterns can it discover?",
      answer: "Our AI can identify various patterns in your communications, including: \n• Emotional patterns in your writing and responses\n• Time-based patterns (productivity peaks, response times)\n• Communication style variations across different contexts\n• Recurring themes or topics in your conversations\n• Relationship dynamics and interaction patterns\n• Personal growth and behavioral trends over time"
    },
    {
      question: "Can I use it for both personal and work emails?",
      answer: "Absolutely! You can use our AI companion for both personal and professional emails. The AI adapts to different contexts and maintains appropriate boundaries. You can even set up separate profiles or tags to keep your personal and work insights organized. Many users find value in using it across both domains to improve their overall communication and self-awareness."
    },
    {
      question: "How long does it take to see meaningful insights?",
      answer: "While you'll receive immediate analysis on individual emails, deeper patterns typically emerge within 1-2 weeks of regular use. The AI's understanding grows more nuanced over time as it learns your communication patterns and preferences."
    }
  ];

  return (
    <Box minH="100vh" bg={bg}>
      <Header />
      
      {/* FAQ Content */}
      <Container maxW={'4xl'} pt={24} pb={12}>
        <VStack spacing={8} as={Container} maxW={'3xl'} textAlign={'center'} mb={12}>
          <Heading fontSize={'4xl'}>Frequently Asked Questions</Heading>
          <Text color={'gray.600'} fontSize={'xl'}>
            Everything you need to know about your AI email companion
          </Text>
        </VStack>

        <Accordion allowMultiple>
          {faqs.map((faq, index) => (
            <AccordionItem key={index}>
              <h2>
                <AccordionButton py={4}>
                  <Box flex="1" textAlign="left" fontWeight="medium" fontSize="lg">
                    {faq.question}
                  </Box>
                  <AccordionIcon />
                </AccordionButton>
              </h2>
              <AccordionPanel pb={4}>
                <Text color={'gray.600'} whiteSpace="pre-line">
                  {faq.answer}
                </Text>
              </AccordionPanel>
            </AccordionItem>
          ))}
        </Accordion>
      </Container>
    </Box>
  );
};

export default FAQ;
